export const PopupsSymbol = Symbol('Popups')
export const CurrentLightboxSymbol = Symbol('CurrentPopup')
export const LightboxUtilsSymbol = Symbol('PopupUtils')
export const LightboxesLinkUtilsAPISymbol = Symbol('PopupsLinkUtilsAPI')

export const name = 'popups' as const
